//todo: remove all!
export const hashCode = (str: string): number => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }
  return hash
}

export const intToRGB = (i: number): string => {
  const c = i % 360

  return 'hsl(' + c + ',100%,30%)'
}

export const hexToRgba = (hex: string, opacity: number) => {
  hex = hex?.replace(/^#/, '')

  const r = parseInt(hex?.substring(0, 2), 16)
  const g = parseInt(hex?.substring(2, 4), 16)
  const b = parseInt(hex?.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b} , ${opacity})`
}
